import React from "react"
import styled from "styled-components"

const StyledParagraph = styled.p`
  padding-block-end: 0.62em;
`
export default function Paragraph({ children }) {
  return <StyledParagraph>{children}</StyledParagraph>
}
